export default __webpack_public_path__ + "static/media/Logout.d42a3007.svg";